import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { supabase } from "../supabaseClient";

// Load dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export const adjustTime = (datetime) => {
  return dayjs(datetime).format("YYYY-MM-DD HH:mm:ss");
};

// Helper function to properly convert UTC to Amsterdam timezone
export const convertUtcToAmsterdam = (utcDatetime) => {
  if (!utcDatetime) return null;
  // Treat the datetime from Supabase as UTC and convert to Amsterdam timezone
  return dayjs(utcDatetime).tz("Europe/Amsterdam");
};

// Helper function to check if signup deadline has passed (with proper timezone handling)
export const isSignupDeadlinePassed = (signupUntil) => {
  if (!signupUntil) return false;

  const signupUntilAmsterdam = convertUtcToAmsterdam(signupUntil);
  const currentTimeAmsterdam = dayjs().tz("Europe/Amsterdam");

  return currentTimeAmsterdam.isAfter(signupUntilAmsterdam);
};

export const adminUserIds = [
  "8561c677-63c0-4abf-8916-798ddd18ec14",
  "ecd42b31-a1de-4fbf-a8f1-35b2998b88db",
  "98146fef-eba8-43e6-b400-c05fb96b526e",
  "ba922432-012a-421d-8d6d-e1eb907d05d1",
  "8e638358-6afc-49d5-9d39-f4aa3cf8c2a0",
  "6606a926-9297-4b32-9c11-ab46578432aa",
  "057919e6-ae5f-405c-b911-6a99a638de1a"
];

export const getPublicImageUrl = (filename) => {
  if (!filename || filename.includes("https://")) {
    return filename;
  }

  const { data } = supabase.storage.from("images").getPublicUrl(filename);

  return data.publicUrl;
};

export const defaultIcons = [
  "heroicons:shopping-bag",
  "heroicons:gift",
  "heroicons:ticket",
  "heroicons:cake",
  "heroicons:heart",
  "heroicons:sparkles",
  "heroicons:currency-dollar",
  "heroicons:tag",
  "heroicons:star",
  "heroicons:fire",
  "heroicons:light-bulb",
  "heroicons:puzzle-piece",
  "heroicons:musical-note",
  "heroicons:camera",
  "heroicons:film",
  "heroicons:book-open",
  "heroicons:academic-cap",
  "heroicons:briefcase",
  "heroicons:truck",
  "heroicons:building-storefront",
];

export const baseUrl =
  process.env.NODE_ENV === "production"
    ? `https://22night.com`
    : "http://localhost:3000";

export const availableGenres = [
  "House",
  "Afro",
  "Classics",
  "Disco",
  "Hard-House",
  "Hits",
  "Latin",
  "Techno",
  "RnB",
  "HipHop",
  "Trance",
  "Urban",
  "Amapiano",
];

export const convertToUTC = (datetime) => {
  const originalDate = new Date(datetime);
  const utcDatetime = new Date(
    originalDate.getTime() - originalDate.getTimezoneOffset() * 60000
  );
  const formattedUtcDatetime = utcDatetime.toISOString();
  return formattedUtcDatetime;
};

export const validateName = (name) => {
  // Only check that the name doesn't contain numbers
  return !/\d/.test(name);
};

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
